<cx-spinner class="overlay" *ngIf="isOrderPlacing"></cx-spinner>
<div class="checkout-totals" *ngIf="orderSummaryDetails">
  <div class="cx-summary-heading">
    {{ "orderSummary.title" | cxTranslate }}
  </div>

  <div class="cx-summary-partials">
    <div class="cx-summary-row">
      <div class="col-6 cx-summary-label">
        <span>{{ "orderSummary.totalQuantity" | cxTranslate }}</span>
      </div>
      <div class="col-6 cx-summary-amount">
        {{ orderSummaryDetails.totalUnitCount }}
        {{ "orderSummary.cases" | cxTranslate }}
      </div>
    </div>
    <div class="cx-summary-row">
      <div class="col-6 cx-summary-label">
        {{ "orderSummary.totalWeight" | cxTranslate }}
      </div>
      <div class="col-6 cx-summary-amount">
        {{ orderSummaryDetails.totalWeight }}
        {{ orderSummaryDetails.weightUnit }}
      </div>
    </div>
    <div class="cx-summary-row">
      <div class="col-6 cx-summary-label">
        {{ "orderSummary.totalVolume" | cxTranslate }}
      </div>
      <div class="col-6 cx-summary-amount">
        {{ orderSummaryDetails?.totalVolume }}
        {{ orderSummaryDetails.volumeUnit }}
      </div>
    </div>
    <div class="cx-summary-row" *ngIf="orderSummaryDetails?.subTotal">
      <div class="col-6 cx-summary-label bold">
        {{ "orderSummary.subtotal" | cxTranslate }}
      </div>
      <div class="col-6 cx-summary-amount">
        {{ orderSummaryDetails?.subTotal?.formattedValue }}
      </div>
    </div>
    <div class="cx-summary-row" *ngIf="orderSummaryDetails?.deliveryCost">
      <div class="col-6 cx-summary-label bold">
        {{ "orderSummary.shipping" | cxTranslate }}
      </div>
      <div class="col-6 cx-summary-amount">
        {{ orderSummaryDetails?.deliveryCost?.formattedValue }}
      </div>
    </div>
    <div class="cx-summary-row" *ngIf="orderSummaryDetails?.surcharge">
      <div class="col-6 cx-summary-label bold">
        {{ "orderSummary.surcharge" | cxTranslate }}
      </div>
      <div class="col-6 cx-summary-amount">
        {{ orderSummaryDetails?.surcharge?.formattedValue }}
      </div>
    </div>
    <div class="cx-summary-row">
      <div class="col-6 cx-summary-label bold">
        {{ "orderSummary.totalexcltax" | cxTranslate }}
      </div>
      <div class="col-6 cx-summary-amount">
        {{ orderSummaryDetails?.totalPrice?.formattedValue }}
      </div>
    </div>
    <div class="cx-summary-row">
      <div class="col-6 cx-summary-label">
        {{ "orderSummary.salesTax" | cxTranslate }}
      </div>
      <div class="col-6 cx-summary-amount">
        {{ orderSummaryDetails?.totalTax?.formattedValue }}
      </div>
    </div>
    <div class="cx-summary-row total-price-row">
      <div class="col-6 cx-summary-label bold">
        {{ "orderSummary.toatlincltax" | cxTranslate }}
      </div>
      <div class="col-6 cx-summary-amount">
        {{ orderSummaryDetails?.totalPriceWithTax?.formattedValue }}
      </div>
    </div>
  </div>
  <div class="checkout-proceed" *ngIf="!isOrderConfirmation">
    <div class="form-group tnc-checkbox-block" [formGroup]="checkoutSubmitForm">
      <label *ngIf="sitecountry[1] !== 'lipton-pk'"
        ><input
          type="checkbox"
          formControlName="termsAndConditions"
          class="scaled-input form-check-input ng-untouched ng-pristine ng-invalid"
          ng-reflect-name="termsAndConditions" /><span class="form-check-label">
          {{ "orderSummary.iagree" | cxTranslate }}
          <a target="_blank" rel="noopener" class="cx-tc-link" href={{privacyPath}}>
            {{ "orderSummary.privacypolicy" | cxTranslate }}
          </a></span></label>
    </div>
    <div class="checkout-button-group">
      <cx-progress-button [class]="'btn btn-block'" (click)="onEditOrderClick()" tabindex="-1">
        {{ "checkoutordersummary.editOrder" | cxTranslate }}
      </cx-progress-button>
      <cx-progress-button [class]="'btn btn-block'" [disabled]="termsAndConditionInvalid" tabindex="-1"
        (click)="onPlaceOrder()">
        {{ "checkoutordersummary.placeOrder" | cxTranslate }}
      </cx-progress-button>
    </div>
  </div>
  <cx-progress-button *ngIf="isOrderDetails" (click)="reorder()" [class]="'btn btn-block reorder-btn'" tabindex="-1" >
    {{ "orderSummary.reorder" | cxTranslate }}
  </cx-progress-button>
</div>